import { render, staticRenderFns } from "./generalinformationview.vue?vue&type=template&id=7fb579dc&"
import script from "./../../ts/partcreation/generalinformationview.ts?vue&type=script&lang=js&"
export * from "./../../ts/partcreation/generalinformationview.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports